import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";
import {RevokeApiTokenContent} from "./payloads/revoke-api-token-content";

/**
 * Action command (ADR-015/016): the logged-in user revokes one of their own API tokens (settings page
 * "Mein Profil", section "API-Tokens"). `mainEntityClass` is `'user'`, `mainEntityUid` the user's own
 * uid; the backend refuses any other uid. Creating a token is not a command of the page: it goes
 * through POST /api/v1/me/api-tokens, which generates the token on the server.
 *
 * No transformer (ADR-016): the payload is a `CommandPayload`, serialized by the generic path.
 */
export class RevokeApiTokenCommand extends AbstractCommand<RevokeApiTokenContent> {

    public name: CommandName = CommandName.REVOKE_API_TOKEN;

    public tags = ['own-profile', 'api-token', 'revoke'];

    constructor(userUid: string, content: RevokeApiTokenContent) {
        super('user', userUid, content);
    }
}
